"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageEngine = void 0;
const storage_key_constants_1 = require("./storage-key-constants");
/**
 * Local storage implementation of a string-valued store for storing a configuration and its metadata.
 *
 * This serializes the entire contents into a single string and then stores it to a single local
 * storage key. Same with metadata about the store (e.g., when it was last updated).
 */
class LocalStorageEngine {
    constructor(localStorage, storageKeySuffix) {
        this.localStorage = localStorage;
        this.getContentsJsonString = async () => {
            return this.localStorage.getItem(this.contentsKey);
        };
        this.getMetaJsonString = async () => {
            return this.localStorage.getItem(this.metaKey);
        };
        this.setContentsJsonString = async (configurationJsonString) => {
            this.localStorage.setItem(this.contentsKey, configurationJsonString);
        };
        this.setMetaJsonString = async (metaJsonString) => {
            this.localStorage.setItem(this.metaKey, metaJsonString);
        };
        const keySuffix = storageKeySuffix ? `-${storageKeySuffix}` : '';
        this.contentsKey = storage_key_constants_1.CONFIGURATION_KEY + keySuffix;
        this.metaKey = storage_key_constants_1.META_KEY + keySuffix;
    }
}
exports.LocalStorageEngine = LocalStorageEngine;
//# sourceMappingURL=local-storage-engine.js.map